import React, { useEffect, useState } from 'react';
// import { FaRocket } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaTimes } from 'react-icons/fa'
import './hiring.css';

function HiringIcon() {
    const [showCard, setShowCard] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setShowCard(false);
        }, 2000);
    }, [])

    const hideBlock = () => {
        setShowCard(false)
    }

    return null;
}
export default HiringIcon